import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import {
  MaterialBannerVo,
  AffUserPaidTaskSubmitVo,
  PaidTaskVo,
  MaterialVo,
  AppUserApplyBo,
  AppLanguageVo,
  TaskCountVo
} from './types';

/**
 * 获取banner图片
 */
export const getTaskBannerList = (query: any): AxiosPromise<MaterialBannerVo> => {
  return request({
    url: '/affiliate/paid/task/bannerList',
    method: 'get',
    params: query
  });
};

/**
 * 提交内容回显
 */
export const getSubmitList = (query: object): AxiosPromise<AffUserPaidTaskSubmitVo> => {
  return request({
    url: '/affiliate/paid/task/submitList',
    method: 'get',
    params: query
  });
};

/**
 * 提交任务
 */
export const affiliateTaskSubmit = (data: { userPaidTaskId: number; links: Array<object> }): AxiosPromise<boolean> => {
  return request({
    url: '/affiliate/paid/task/submit',
    method: 'post',
    data
  });
};

/**
 * 获取任务列表
 */
export const getAffiliateTaskList = (data: { status: number }): AxiosPromise<PaidTaskVo> => {
  return request({
    url: '/affiliate/paid/task/taskList',
    method: 'post',
    data
  });
};

/**
 * 获取素材标签下拉
 */
export const getPromotionTag = () => {
  return request({
    url: '/affiliate/promotion/material/tagDropdown',
    method: 'get'
  });
};

/**
 * 获取素材列表数据
 */
export const getPromotionList = (data: { pageSize: number; pageNum: number; tagId?: number }): AxiosPromise<MaterialVo[]> => {
  return request({
    url: '/affiliate/promotion/material/list',
    method: 'post',
    data
  });
};

/**
 * 社交媒体列表
 */
export const userSocialPlatform = (): AxiosPromise<boolean> => {
  return request({
    url: '/affiliate/user/socialPlatform',
    method: 'get'
  });
};
/**
 * 推荐链接
 */
export const userReferralCode = (): AxiosPromise<boolean> => {
  return request({
    url: '/affiliate/user/referralCode',
    method: 'get'
  });
};

/**
 * 网红申请
 */
export const userApply = (data: AppUserApplyBo): AxiosPromise<boolean> => {
  return request({
    url: '/affiliate/user/apply',
    method: 'post',
    data
  });
};

/**
 * 语言列表
 */
export const languageList = (): AxiosPromise<AppLanguageVo> => {
  return request({
    url: '/system/app/language/list',
    method: 'get'
  });
};

/**
 * 任务数量
 */
export const taskCount = (): AxiosPromise<TaskCountVo> => {
  return request({
    url: '/affiliate/paid/task/taskCount',
    method: 'get'
  });
};
